import type {InputHTMLAttributes, ReactNode, Ref, RefObject} from "react";

import {
    type ISearchComboboxListboxDomProps,
    SearchComboboxMobileField,
    SearchComboboxMobileLayer,
    useVisualViewportHeight
} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";

interface IProps {
    isOpen: boolean;
    /** ← and Esc; the caller takes the history entry back (`usePricesSearchLayerHistory`). */
    onClose: () => void;
    /** `getInputProps(...)` - the layer input owns the combobox while the layer is open. */
    inputProps: InputHTMLAttributes<HTMLInputElement>;
    inputRef: RefObject<HTMLInputElement | null>;
    /** The control that opened the layer, focused again after closing. */
    returnFocusRef: RefObject<HTMLElement | null>;
    /** Added to the combobox `rootRefs` - the layer is portalled out of the search form. */
    layerRef: Ref<HTMLDivElement>;
    listboxProps: ISearchComboboxListboxDomProps;
    /** `SearchComboboxFieldControls size="mobile"`. */
    controls?: ReactNode;
    /** The live region - everything outside the modal is hidden from assistive technology while it is open. */
    liveRegion?: ReactNode;
    children: ReactNode;
}

/**
 * Full-screen search on viewports below 1024px. The input is focused while the tap that opens the layer is
 * still being handled, so iOS raises the keyboard; the height follows the visual viewport, so the end of the list stays
 * above the keyboard.
 */
export const PricesSearchLayer = (props: IProps) => {
    const {isOpen, onClose, inputProps, inputRef, returnFocusRef, layerRef, listboxProps, controls, liveRegion, children} = props;

    useVisualViewportHeight(isOpen);

    return (
        <SearchComboboxMobileLayer
            isOpen={isOpen}
            onClose={onClose}
            field={
                <>
                    <SearchComboboxMobileField inputProps={inputProps} inputRef={inputRef} controls={controls} label={PRICES_SEARCH_COPY.inputLabel} />
                    {liveRegion}
                </>
            }
            listboxProps={listboxProps}
            initialFocusRef={inputRef}
            returnFocusRef={returnFocusRef}
            layerRef={layerRef}
            label={PRICES_SEARCH_COPY.layerLabel}
            backLabel={PRICES_SEARCH_COPY.layerBackLabel}
            dataTestId={PRICES_SEARCH_TEST_IDS.MOBILE_LAYER}
            backDataTestId={PRICES_SEARCH_TEST_IDS.MOBILE_BACK}
        >
            {children}
        </SearchComboboxMobileLayer>
    );
};
import type {InputHTMLAttributes, ReactNode, Ref, RefObject} from "react";

import {
    type ISearchComboboxListboxDomProps,
    SearchComboboxMobileField,
    SearchComboboxMobileLayer,
    useVisualViewportHeight
} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import {PRICES_SEARCH_COPY} from "../../constants/prices_search";

interface IProps {
    isOpen: boolean;
    /** ← and Esc; the caller takes the history entry back (`usePricesSearchLayerHistory`). */
    onClose: () => void;
    /** `getInputProps(...)` - the layer input owns the combobox while the layer is open. */
    inputProps: InputHTMLAttributes<HTMLInputElement>;
    inputRef: RefObject<HTMLInputElement | null>;
    /** The control that opened the layer, focused again after closing. */
    returnFocusRef: RefObject<HTMLElement | null>;
    /** Added to the combobox `rootRefs` - the layer is portalled out of the search form. */
    layerRef: Ref<HTMLDivElement>;
    listboxProps: ISearchComboboxListboxDomProps;
    /** `SearchComboboxFieldControls size="mobile"`. */
    controls?: ReactNode;
    /** The live region - everything outside the modal is hidden from assistive technology while it is open. */
    liveRegion?: ReactNode;
    children: ReactNode;
}

/**
 * Full-screen search on viewports below 1024px. The input is focused while the tap that opens the layer is
 * still being handled, so iOS raises the keyboard; the height follows the visual viewport, so the end of the list stays
 * above the keyboard.
 */
export const PricesSearchLayer = (props: IProps) => {
    const {isOpen, onClose, inputProps, inputRef, returnFocusRef, layerRef, listboxProps, controls, liveRegion, children} = props;

    useVisualViewportHeight(isOpen);

    return (
        <SearchComboboxMobileLayer
            isOpen={isOpen}
            onClose={onClose}
            field={
                <>
                    <SearchComboboxMobileField inputProps={inputProps} inputRef={inputRef} controls={controls} label={PRICES_SEARCH_COPY.inputLabel} />
                    {liveRegion}
                </>
            }
            listboxProps={listboxProps}
            initialFocusRef={inputRef}
            returnFocusRef={returnFocusRef}
            layerRef={layerRef}
            label={PRICES_SEARCH_COPY.layerLabel}
            backLabel={PRICES_SEARCH_COPY.layerBackLabel}
            dataTestId={PRICES_SEARCH_TEST_IDS.MOBILE_LAYER}
            backDataTestId={PRICES_SEARCH_TEST_IDS.MOBILE_BACK}
        >
            {children}
        </SearchComboboxMobileLayer>
    );
};
